import axios from 'axios';
import React, {useEffect, useState} from 'react';
import PublicProfileItemCard from '../PublicProfileItemCard';
import defaultStyle from './publicProfileSectionCard.module.scss';
import desktopPreviewStyle from './publicProfileSectionCard_desktop-preview.module.scss';
import mobilePreviewStyle from './publicProfileSectionCard_mobile-preview.module.scss';
import {useTranslation} from 'react-i18next';
import {MediakitSectionItem} from './../../features/stores/mediakitUser.slice';
import {previewStyles} from '../../constants/theme';
import useWindowWidth from '../../hooks/useWindowWidth';
import PublicProfileFeaturedContentSection from '../PublicProfileFeaturedContentSection';

interface IPublicProfileSectionJsx {
  id: string;
  isVisible: boolean;
  mediakitSectionLinks: MediakitSectionItem[];
  title: string;
  subtitle: string
  type: string;
  theme: any;
  selectedStyle: string;
  mediakitUserId: string;
  ownerUserId?: string;
  nickname?: string;
  email?: string;
  setMonitizeID: React.Dispatch<React.SetStateAction<any>>;
  setMonetizeObj?: React.Dispatch<React.SetStateAction<any>>;
  enableSubtitle?: boolean;
  maxDesktopContainerWidth: string;
}

const PublicProfileSectionCard = ({
  id,
  isVisible,
  mediakitSectionLinks,
  title,
  subtitle,
  type,
  selectedStyle,
  mediakitUserId,
  theme,
  ownerUserId,
  nickname,
  email,
  setMonitizeID,
  setMonetizeObj,
  enableSubtitle,
  maxDesktopContainerWidth,
}:IPublicProfileSectionJsx) => {
  const {t, i18n} = useTranslation();
  const [items, setItems] = useState(mediakitSectionLinks) as any;
  const mobile = useWindowWidth();

  let styles: any = '';
  if (selectedStyle === previewStyles.DESKTOP_PREVIEW) styles = desktopPreviewStyle;
  if (selectedStyle === previewStyles.MOBILE_PREVIEW) styles = mobilePreviewStyle;
  if (selectedStyle === previewStyles.DEFAULT) styles = defaultStyle;


  const translate = (key : string) => {
    return t(key, {lng: theme.displayLocale || 'en'});
  };

  const fetchThumbnailData = async (array: any, setter:Function)=>{
    // function only to provide legacy supporty for videos in DB that dont have thumbnails saved
    let newArray = [] as any;
    newArray = await Promise.all(array.map(async (item: MediakitSectionItem)=>{
      if (!item.videoThumbnail) {
        const videoUrl = `https://www.youtube.com/oembed?url=${item.url}`;
        const videoDetails = await axios.get(videoUrl);
        if (videoDetails.data) {
          return {
            ...item,
            videoThumbnail: videoDetails.data.thumbnail_url,
          };
        };
      } else return item;
    }));
    setter(newArray);
  };

  useEffect(() => {
    const itemList = mediakitSectionLinks?.slice().sort((a: any, b: any) => {
      if (type === 'video') {
        if (a.orderNumber > b.orderNumber) return 1;
        else return -1;
     } else {
        if (a.orderNumber > b.orderNumber) return 1;
        else return -1;
      }
    });
    if (type === 'video') fetchThumbnailData(itemList, setItems);
    setItems(itemList);
  }, [mediakitSectionLinks]);

  const width = useWindowWidth();

  return (
    <div className={styles.container}
    style={selectedStyle === previewStyles.DESKTOP_PREVIEW ? {
      maxWidth: maxDesktopContainerWidth,
    }: {}}
    >
      {/* {
        type !== 'important_links' &&
        <div className={styles.title_subtitle_wrapper}>
          <span className={styles.title}
            style={{
              // fontFamily: isArabic(i18n.language) ? theme.arabicFont! : theme.englishFont!,
              fontFamily: theme.englishFont!,
              color: theme.nonCardTextColor!}}
          >{translate(title)}</span>

          {subtitle ? <span className={styles.subtitle} style={{color: theme.nonCardTextColor!}}>{translate(subtitle)}</span> : null}
        </div>
      } */}
      {(type === 'video') ? <PublicProfileFeaturedContentSection
                  mediakitUserId={mediakitUserId}
                  sectionType={type}
                  selectedStyle={selectedStyle}
                  theme={theme}
                  items={items}
                  ownerUserId={ownerUserId}
                  nickname={nickname}
                  email={email}
                  setMonitizeID={setMonitizeID}
                  setMonetizeObj={setMonetizeObj}
                /> :
        <div
          className={type === 'video' && (selectedStyle === 'mobile-preview' || mobile < 769) ? styles.video_wrapper : styles.links_wrapper}
          style={{...(type === 'video' && width <= 768 && selectedStyle === 'desktop-preview' && {display: 'flex', gridGap: '4px', gap: '4px', justifyContent: 'space-between', flexWrap: 'wrap'})}}
        >
          {items?.map((item: any, index: number) => {
            return (
              <div className={type == 'rates' ? styles.links : ''} key={item.id}>
                <PublicProfileItemCard
                  mediakitUserId={mediakitUserId}
                  sectionType={type}
                  selectedStyle={selectedStyle}
                  theme={theme}
                  index={index}
                  item={item}
                  ownerUserId={ownerUserId}
                  nickname={nickname}
                  email={email}
                  setMonitizeID={setMonitizeID}
                  setMonetizeObj={setMonetizeObj}
                />
              </div>
            );
          })}
        </div>}
    </div>
  );
};

export default PublicProfileSectionCard;
